import { BuildingReviewLandingStrategyInterface } from 'common/module/building-review-landing/strategy.interface';
import { BuildingReviewLandingAutocompleteStatechartService } from 'common/service/building-review-landing-autocomplete-statechart/service';
import { BuildingReviewLandingStrategy } from 'desktop/module/building-review-landing/strategy';
import { BuildingReviewLandingAutocompleteService } from 'desktop/service/building-review-landing-autocomplete/service';

export function BuildingReviewLandingStrategyFactory(): BuildingReviewLandingStrategyInterface {
  return new BuildingReviewLandingStrategy(
    BuildingReviewLandingAutocompleteService(),
    BuildingReviewLandingAutocompleteStatechartService()
  );
}
